import { render, staticRenderFns } from "./quels-objectifs-marketing-pouvez-vous-atteindre-grace-a-instagram-ads.vue?vue&type=template&id=82fb161a&"
import script from "./quels-objectifs-marketing-pouvez-vous-atteindre-grace-a-instagram-ads.vue?vue&type=script&lang=js&"
export * from "./quels-objectifs-marketing-pouvez-vous-atteindre-grace-a-instagram-ads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports